import { observer } from 'mobx-react-lite'
import { CollapseWithIcon } from 'shared/ui'
import { IntegrationSettingsUsers } from 'pages/settings/pages/integrations/pages/integrationSettings/ui/IntegrationSettingsUsers/IntegrationSettingsUsers'
import type { IntegrationSettingsUsersStore } from 'pages/settings/pages/integrations/pages/integrationSettings/store/IntegrationSettingsUsersStore'
import type { IntegrationCollapseSettingsStore } from 'pages/settings/pages/integrations/pages/integrationSettings/store/IntegrationCollapseSettingsStore'

import sharedStyles from 'pages/settings/pages/integrations/pages/integrationSettings/ui/styles.module.scss'
import styles from './styles.module.scss'

type ICollapseIntegrationSettingsUsersProps = {
  collapseStore: IntegrationCollapseSettingsStore
  userStore: IntegrationSettingsUsersStore
}

export const CollapseIntegrationSettingsUsers = observer(
  ({ collapseStore, userStore }: ICollapseIntegrationSettingsUsersProps) => {
    return (
      <CollapseWithIcon
        opened={collapseStore.opened('users')}
        onClick={collapseStore.onToggle('users')}
        icon={'userLine'}
        title={'Users'}
        subtitle={userStore.userInfo.subtitle}
        label={userStore.userInfo.label}
        headerClassName={sharedStyles.collapseWithIcon}
        contentClassName={userStore.canAutoMapUsers ? styles.usersContent : undefined}
      >
        <IntegrationSettingsUsers store={userStore} />
      </CollapseWithIcon>
    )
  }
)
